module.exports = ".title-table{text-align:center}\n"